<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :show-close="false"
    width="40%"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('carMonitor.terminalControl.title')"
      :icon="'icon-dialog-add'"
      @close="closeDialog"
    />
  
      <vue-linetitle style="padding-top:10px" class="loading-control">
        <div style="height: 60vh">
          <el-tabs v-model="activeName" type="card" >
            <el-tab-pane :label="$t('carMonitor.terminalControl.fileManagement')" name="1">
              <!-- 终端文件管理 -->
              <!-- <div>
                <el-button type="primary">查询固件版本</el-button>
                &emsp;<span>固件版本: {{ versions }}</span>
              </div> -->
              <div style="padding: 10px 0">
                <el-button type="primary" @click="loadDir">{{ $t('carMonitor.terminalControl.loadDir') }}</el-button>
                <!-- <el-button type="primary">设置默认DBC</el-button> -->
                <el-button type="primary" @click="processVisibles=true;progress=0;_downloadFile()" :disabled="disabled">{{ $t('carMonitor.terminalControl.downloadFiles') }}</el-button>
                <!-- <el-button type="primary">删除文件</el-button> -->
                <!-- <el-button type="primary">下发文件</el-button> -->
              </div>

              <div style="height: 40vh">
                <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
                  <el-tree 
                  :data="treeData" 
                  node-key="functionId"
                  :default-expanded-keys="defaulExpendKeys"
                  :expand-on-click-node="false"
                  >
                  
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span @click="clickTree(data)">
                      <svg-icon 
                      :icon-class="data.isLeaf==0?'dir': 'file'"
                      :style="{ color: data.icon=== 'O' ? '#409EFF':'#bfbfbf'}"
                      />&nbsp;<span>{{ data.functionName }}
                        &nbsp; <span v-if="data.isLeaf===1">({{ data.remark }})</span>
                      </span>
                    </span>
                   </span>
                  
                  </el-tree>
                </el-scrollbar>
              </div>
              
            </el-tab-pane>
            <el-tab-pane :label="$t('carMonitor.terminalControl.shellCommandTitle')" name="2">
              <el-form ref="form" label-position="right"  label-width="70px">
              <el-form-item :label="$t('carMonitor.terminalControl.shellCommand')+'：'">
                <el-input
                :style="{width: lang == 'zh' ? 'calc(100% - 70px)':'calc(100% - 110px)'}"
                  filterable
                  clearable
                  v-model="command"
                  :autosize="{ minRows: 3, maxRows: 3}"
                  @keydown.native="listen($event)"
                  resize="none"
                  type="textarea">
                </el-input>
                <el-button 
                style="margin-left: 14px" 
                type="primary"
                @click="startShell"
                >{{ $t('carMonitor.terminalControl.implement') }}</el-button>
              </el-form-item>
              <el-form-item :label="$t('carMonitor.terminalControl.res')+'：'">
              <!-- <el-input
                v-model="res"
                :rows="3"
                :autosize="{ minRows: 8, maxRows: 8}"
                resize="none"
                type="textarea"/> -->
                <div style="height: 36vh">
                  <el-input
                    type="textarea"
                    :rows="10"
                    :value="res"
                    readonly
                  />
                  <!-- <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
                    <div style="padding:0 10px;min-height: 150px;border: 1px solid #DCDFE6;border-radius: 4px;color: #55C3B5 ">
                      <textarea v-text="res"></textarea>
                    </div>
                    
                  </el-scrollbar> -->
                </div>

              </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </vue-linetitle>
       <el-dialog
        v-if="processVisibles"
        v-el-drag-dialog
        append-to-body
        :close-on-click-modal="false"
        :visible.sync="processVisibles"
        :lock-scroll="false"
        :show-close="false"
        width="30%"
        top="30vh"
        center
      >
      <dialog-header
        slot="title"
        :title="$t('carMonitor.terminalControl.systemPrompt')"
        :icon="'process'"
        :close-icon="''"
      />
     <vue-linetitle>
        <div style="padding: 0px 10px 20px 10px">
          <p>{{ $t('carMonitor.terminalControl.downloadingData') }}</p>
          <el-progress :text-inside="true" :stroke-width="26" :percentage="progress"></el-progress>
        </div>
      </vue-linetitle>
      <div style="height: 10px"></div>
      </el-dialog>
  </el-dialog>
</template>
<script>
// request
import { 
  getTerminalDir, 
  downloadFile, 
  shellInput 
} from "@/api/carMonitor/terminalControl"
import { Loading } from 'element-ui'
// 混入
export default {
  name: 'controlDialog',
  // components: { appOrganizePicker },
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeName: '1',
      res: '',
      disabled: true,
      treeData: [],
      selectTree: {},
      defaulExpendKeys: [],
      first: true,
      loadingControl: null,
      processVisibles: false,
      progress: 0,
      command: '',
      failCount: 0
    }
  },
  computed: {
    lang() {
      return this.$store.getters.language
    }
  },
  created(){
  },
  methods: {
    restData() {
      this.activeName = '1'
      this.res = ''
      this.disabled = true
      this.treeData = []
      this.selectTree = {}
      this.defaulExpendKeys = []
      this.first = true
      this.loadingControl = null
      this.processVisibles = false
      this.progress = 0
      this.command = ''
    },
    listen (event) {
      if (event.keyCode === 13) {
        this.startShell() // 发送文本
        event.preventDefault() // 阻止浏览器默认换行操作
        return false
      }
    },
    // 关闭dialog
    closeDialog() {
      this.restData()
      this.$emit('update:visibles', false)
    },
    loadDir() {
      this.loadingControl = Loading.service({
        target: '.loading-control',
        text: 'Loading...'
      })
      this.defaulExpendKeys = []
      this.disabled = true
      // LNB20200073030647
      // const terminal = process.env.NODE_ENV === 'development' ?  'LNB20200073030647' : this.data.terminalCode
      getTerminalDir(this.data.terminalCode).then(({data})=> {
        // console.log(data)
        if(data.code==0) {
          this.treeData = data.data || []
          this.setdefaulExpendKeys(this.treeData[0].children)
        }
        this.loadingControl.close()
      }).catch(()=>{
        this.loadingControl.close()
      }).finally(()=>{
        this.loadingControl.close()
      })
    },
    clickTree(data){
      this.first = true
      this.disabled = data.isLeaf===1 ? false : true
      this.selectTree = data
    },
    setdefaulExpendKeys(data){
      data.forEach(item=>{
        item.isLeaf && this.defaulExpendKeys.length===0 && this.defaulExpendKeys.push(item.functionId)
        if(item.children && item.children.length>0) {
          this.setdefaulExpendKeys(item.children)
        }
      })
    },
    _downloadFile() {
      const postData = {
        terminal: this.data.terminalCode,
        fileName: this.selectTree.url,
        first: this.first
      }
      downloadFile(postData).then(({data})=>{
        if(data.code===0){
          this.first = false
          this.failCount = 0
          this.progress = data.data && data.data.progress || 0
          if(this.progress<100){
            
            let timer = setTimeout(()=> {
              this._downloadFile()
              window.clearTimeout(timer)
            },1000)
          }else{
              data.data && data.data.filePath && window.open(data.data.filePath)
            this.processVisibles = false
          }
        }else{
          // this.loadFailFun()
           this.processVisibles = false
           this.first = true
        }
      })
      .catch(()=>{
        this.loadFailFun()
      })
    },
    loadFailFun(){
      if(this.failCount>=3){
        this.processVisibles = false
        return 
      }
      this.first = true
      let timer = setTimeout(()=> {
        this._downloadFile()
         window.clearTimeout(timer)
      },1000)
      this.failCount++
    },
    startShell() {
      const postData = {
        terminal: this.data.terminalCode,
        command: this.command
      }
      if(!this.command) return
      shellInput(postData).then(({data})=>{
        if(data.code===0) {
          this.res = data.data || ''

        }
      })
    }
  }
}
</script>
<style lang="scss">
// .textareaStyle textarea{
//   height: 80px!important;
// }
</style>
